/**
 * @author piotrzurek
 * @since 2021-12-3
 */

import * as React from "react";
import styled from "styled-components";

import { TestWrapper } from "@ui/Atoms";

interface Props {
  children?: React.ReactNode;
  testId?: string;
}

const Panel = (props: Props): React.ReactElement => (
  <TestWrapper testId={props.testId}>
    <PanelWrapper>{props.children}</PanelWrapper>
  </TestWrapper>
);

export { Panel };

const PanelWrapper = styled.div`
  border: 1px solid ${props => props.theme.palette.blue500};
  border-radius: ${props => props.theme.border.radius.half};
  padding: ${props => props.theme.margins.base};
`;
